import { TextareaHTMLAttributes, useId } from 'react'

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  error?: string
  hint?: string
}

export function Textarea({ label, error, hint, className = '', id, ...props }: TextareaProps) {
  const generatedId = useId()
  const textareaId = id || generatedId

  // If no label, render just the textarea element
  if (!label) {
    return (
      <textarea
        id={textareaId}
        className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-tessan-green focus:border-transparent transition-colors resize-none ${
          error ? 'border-error' : 'border-gray-300'
        } ${className}`}
        {...props}
      />
    )
  }

  return (
    <div className="space-y-1">
      <label htmlFor={textareaId} className="block text-sm font-medium text-text-primary">
        {label}
        {props.required && <span className="text-error ml-1">*</span>}
      </label>
      <textarea
        id={textareaId}
        className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-tessan-green focus:border-transparent transition-colors resize-none ${
          error ? 'border-error' : 'border-gray-300'
        } ${className}`}
        {...props}
      />
      {hint && !error && (
        <p className="text-xs text-text-muted">{hint}</p>
      )}
      {error && (
        <p className="text-xs text-error">{error}</p>
      )}
    </div>
  )
}
